import React, { Suspense, useState } from "react";

import { Paper, TableRow, TableCell, Grid } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { Title, MasterButton } from "App/Component/ui";
import {
  STYLE_DEFAULT_MASTER,
  instance3,
  DISABLED_BUTTON_SUBMIT,
} from "App/constants";
import { useDatatables } from "App/hooks";
import FormServiceTutupTagihan from "./FormServiceTutupTagihan";
import { RESET_STATE_SERVICE_TUTUP_TAGIHAN, headCells } from "./helpers";
import {
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { SHOW_PROCESS } from "App/Component/layout/Wms/PerbekalanFarmasi/InventoryControl/InputAdjusmentStock/ui/ModalSimpan/ModalSimpan";
import TableListServiceTutupTagihan from "./TableListServiceTutupTagihan";
import { LoadingBackdrop } from "components/atoms";
import { FreezeTableClient } from "components/organism";
export default function ServiceTutupTagihan() {
  const classes = STYLE_DEFAULT_MASTER();
  const [rowsListTagihan, setRowsListTagihan] = useState([]);
  const [formData, setFormData] = useState(RESET_STATE_SERVICE_TUTUP_TAGIHAN);
  const [file, setFile] = useState(null);
  const [disabled, setDisabled] = useState(SHOW_PROCESS);

  const handleClickProses = async () => {
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (!isNull(formData.id)) {
        const response = await instance3.post("/servpemb_tagihan/process", {
          id: formData.id,
        });

        if (response.data.status === 200) {
          defaultToastSuccess(response.data.message);
          setRowsListTagihan(response.data.data);
        } else {
          defaultToastError(response.data.message);
        }

        setDisabled(SHOW_PROCESS);
      } else {
        setDisabled(SHOW_PROCESS);
        defaultToastError("Buka Transaksi terlebih dahulu");
      }
    } catch (error) {
      setDisabled(SHOW_PROCESS);
      defaultToastError(error.response?.data?.message);
    }
  };
  return (
    <Suspense fallback={<LoadingBackdrop />}>
      <div className={classes.root}>
        <Title title={"Service Tutup Tagihan"} />

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}>
          <Grid container spacing={3}>
            <Grid item sm={4}>
              <FormServiceTutupTagihan
                formData={formData}
                setFormData={setFormData}
                file={file}
                setRowsListTagihan={setRowsListTagihan}
                setFile={setFile}
              />
            </Grid>
            <Grid item sm={8}>
              <TableListTagihan rows={rowsListTagihan} />

              {!isNull(formData.id) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "1rem",
                  }}>
                  <MasterButton
                    type={"button"}
                    color={disabled.color}
                    name={disabled.label}
                    onClick={handleClickProses}
                    size='md'
                  />
                </div>
              )}
            </Grid>
          </Grid>
        </Paper>

        <div className='mt-1'>
          <TableListServiceTutupTagihan />
        </div>
      </div>
    </Suspense>
  );
}

export const TableListTagihan = ({ rows }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "tagihan_id",
    orderByRow: ["tagihan_id"],
  });

  return (
    <FreezeTableClient
      title='Daftar Tagihan dari Excel'
      setQ={setQ}
      withAddButton={false}
      withExportButton={false}
      order={order}
      orderBy={orderBy}
      handleRequestSort={handleRequestSort}
      length={length}
      rows={rows}
      headCells={headCells}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}>
      {stableSort(data, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {
          return (
            <TableRow
              hover
              tabIndex={-1}
              key={index}
              style={{
                backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
              }}>
              <TableCell
                component='th'
                scope='row'
                padding='none'
                align='center'>
                {index + 1}
              </TableCell>

              <TableCell align='left'>
                {isNull(row.id) ? row.tagihan_id : row.id}
              </TableCell>
              <TableCell align='left'>
                {defaultDateDisplay(row.tanggal_tagihan, true)}
              </TableCell>
              <TableCell align='left'>{row.nama}</TableCell>
              <TableCell align='left'>
                {isNull(row.remark) ? row.keterangan : row.remark}
              </TableCell>
            </TableRow>
          );
        })}
    </FreezeTableClient>
  );
};
